import { useMemo } from "react";
import usePdpCarousels from "src/hooks/usePdpCarousels";
import {
  PDP_SIMILAR_ITEMS_CAROUSEL_ID,
  POPUP_SIMILAR_ITEMS_LIMIT,
} from "src/utils/constants";
import { CatalogProduct, ProductGender } from "src/types/graphql.d";

interface AddedToCartSuggestionsHook {
  title: string | undefined;
  products: CatalogProduct[];
  loading: boolean;
  /** Constructor beacon metadata of the pod these suggestions came from. */
  podId: string | undefined;
  resultId: string | undefined;
  strategyId: string | undefined;
}

/**
 * Products suggested in the "Added to bag" popup: the first items of the PDP
 * similar-items carousel, minus the product the user just added.
 */
const useAddedToCartSuggestions = ({
  productId,
  productSlug,
  shopType,
}: {
  productId: string;
  productSlug: string;
  shopType: ProductGender;
}): AddedToCartSuggestionsHook => {
  const { data, loading } = usePdpCarousels({ slug: productSlug, shopType });

  const { title, products, podId, resultId, strategyId } = useMemo(() => {
    const carousel = data?.pdpCarousels?.carousels?.find(
      ({ id }) => id === PDP_SIMILAR_ITEMS_CAROUSEL_ID
    );

    return {
      title: carousel?.title,
      products: (carousel?.products ?? [])
        .filter(({ id }) => id !== productId)
        .slice(0, POPUP_SIMILAR_ITEMS_LIMIT),
      podId: carousel?.pod_id ?? undefined,
      resultId: carousel?.result_id ?? undefined,
      strategyId: carousel?.strategy_id ?? undefined,
    };
  }, [data, productId]);

  return { title, products, loading, podId, resultId, strategyId };
};

export default useAddedToCartSuggestions;
